import React from "react";
import { useCardcaseModel } from "../cardcaseModel";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData, dataGroupSource
    } = useCardcaseModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "收藏的名片",
            fieldName: "userName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "被收藏的名片",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "电话",
            fieldName: "phone",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "分组",
            fieldName: "typeCode",
            options: dataGroupSource.map(item => ({ label: item.name ?? "", value: item.code ?? "" }))
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["创建开始时间", "创建结束时间"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },

    ]

    return (
        <YhPageHeader
            title="名片夹管理"
            justify="end"
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}